$(document).ready(function () {
  // Make body the active element on page load
  document.body.focus();
  document.activeElement.blur();
});

function updateSearchUrl(searchValue) {
    const newUrl = window.location.origin + '/search?q=' + searchValue;
    window.history.replaceState(null, '', newUrl);
}

// Function to show thumb image
function showThumbImage(containerSelector) {
    showImages(containerSelector, true);
}

// Function to show featured image
function showFeaturedImage(containerSelector) {
    showImages(containerSelector, false);
}

function showImages(containerSelector, showThumb) {
    const productCardContainers = document.querySelectorAll(containerSelector);
    productCardContainers.forEach(productCardContainer => {
        const thumbImage = productCardContainer.querySelector('.thumbImage');
        const featuredImage = productCardContainer.querySelector('.featuredImage');

        if (thumbImage && featuredImage) {
            thumbImage.style.display = showThumb ? 'block' : 'none';
            featuredImage.style.display = showThumb ? 'none' : 'block';
        }
    });
}
